// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".schema-item[data-v-2034af66] {\n  background-color: var(--v-gray_20-base);\n  border: 1px solid var(--v-gray_20-base);\n  width: 154px;\n  height: 64px;\n  border-radius: 4px;\n}\n.schema-item[data-v-2034af66]:hover {\n  background-color: var(--v-gray_20-base);\n  border: 1px solid var(--v-gray_50-base);\n}\n.drag-enabled[data-v-2034af66] {\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n.drag-disabled[data-v-2034af66] {\n  cursor: pointer;\n}", ""]);
// Exports
module.exports = exports;
